import { init } from "./modules/colorScheme";
import { FlashbangObject } from "./modules/flashbangObject";
import { GrenadeObjectSource } from "./modules/grenadeObjectSource";
import { SmokebombObject } from "./modules/smokebombObject";

const flashButton = document.getElementById("flash-button");
if (!flashButton) throw new Error("No element with id='flash-button' detected")
new GrenadeObjectSource(flashButton, FlashbangObject, {
  bounciness: 0.6,
  // detonationDelayInMs: 99999,
});

const smokeButton = document.getElementById("smoke-button");
if (!smokeButton) throw new Error("No element with id='smoke-button' detected")
new GrenadeObjectSource(smokeButton, SmokebombObject, {
  bounciness: 0.1,
});

init(flashButton, smokeButton)